import BaseComponent from 'scripts/BaseComponent.js';

export default class LockBoxEngraving extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      initialsInput: '.js-initialsInput',
      initialsText: '.js-initialsText',
      engravingInput: '.js-engravingInput',
    };

    this.dom = {
      $component: component,
      $initialsInput: this.$get(this.refs.initialsInput),
      $initialsText: this.$get(this.refs.initialsText),
      $engravingInput: document.querySelector(this.refs.engravingInput),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setOnEventWithElement('input', dom.$initialsInput, this.updateEngraving);
  }

  updateEngraving(input) {
    const { dom } = this;
    dom.$initialsText.textContent = input.value;
    dom.$engravingInput.value = input.value;
  }
}
